import { logger as obsLogger } from '@fiverr-private/obs';

const appname = 'support_chat_package';
const subsystemname = appname;

class Logger {
    static consumerFunnelName = 'unset';
    static consumerSectionName = 'unset';

    static getSharedEnrichment() {
        return {
            appname,
            subsystemname,
            consumer_funnel_name: Logger.consumerFunnelName,
            consumer_section_name: Logger.consumerSectionName,
        };
    }

    static warn(entity, enrichment) {
        obsLogger.warn(entity, {
            ...(typeof enrichment === 'object' ? enrichment : { enrichment }),
            ...Logger.getSharedEnrichment(),
        });
    }

    static error(entity, enrichment) {
        obsLogger.error(entity, {
            ...(typeof enrichment === 'object' ? enrichment : { enrichment }),
            ...Logger.getSharedEnrichment(),
        });
    }

    static info(entity, enrichment) {
        obsLogger.info(entity, {
            ...(typeof enrichment === 'object' ? enrichment : { enrichment }),
            ...Logger.getSharedEnrichment(),
        });
    }

    static debug(entity, enrichment) {
        obsLogger.debug(entity, {
            ...(typeof enrichment === 'object' ? enrichment : { enrichment }),
            ...Logger.getSharedEnrichment(),
        });
    }
}

export const logger = Logger;
